import { apiCall } from '../../utils/restclient'
import { RESET_PASSWORD, RESET_PASSWORD_ERROR, RESET_PASSWORD_SUCCESS } from './forgotPasswordConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function resetPassword(loginObj) {
  const endpoint = 'api/v1/auth/forgotpassword'
  const action = {
    type: RESET_PASSWORD,
    payload: { endpoint, body: { ...loginObj } },
  }
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(endpoint, 'POST', null, JSON.stringify(action.payload.body), {
    success: RESET_PASSWORD_SUCCESS,
    error: RESET_PASSWORD_ERROR,
  })
  return action
}
